export class GridItemSpanLookuper {
    constructor(columnCount, prominence) {

        /**
         * These lookup tables provide a column span value for a prominence key.
         Some examples:
         * A grid item with a prominence of "1"    on a one column grid      will get a span of 1.
         * A grid item with a prominence of "2"    on a two column grid      will get a span of 2.
         * A grid item with a prominence of "2"    on a three column grid    will get a span of 2.
         This data *must* match up with whatever CSS rules apply on the collection grid.
         */

        this.gridItemOneColumnSpanLookup = {"1": 1, "2": 1, "3": 1};
        this.gridItemTwoColumnSpanLookup = {"1": 1, "2": 2, "3": 2};
        this.gridItemThreeColumnSpanLookup = {"1": 1, "2": 2, "3": 3};
        this.gridItemFourColumnSpanLookup = {"1": 1, "2": 2, "3": 4};

        // Here the key is the number of columns.
        this.gridColumnsSpanLookup = {
            "1": this.gridItemOneColumnSpanLookup,
            "2": this.gridItemTwoColumnSpanLookup,
            "3": this.gridItemThreeColumnSpanLookup,
            "4": this.gridItemFourColumnSpanLookup,
        }

        this.columnCount = columnCount;
        this.prominence = prominence;
    }

    getSpan() {
        const columnCountKey = this.columnCount.toString();
        const spanLookup = this.gridColumnsSpanLookup[columnCountKey];
        let span = spanLookup[this.prominence.toString()];
        return span || 1;
    }
}